import { createStore, applyMiddleware, compose } from 'redux'
import storage from 'redux-persist/lib/storage'

import thunkMiddleware from 'redux-thunk'

import rootReducer from './root-reducer'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const persistConfig = {
  key: 'root',
  storage,
}

const middlewares = [thunkMiddleware]

export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(...middlewares)))
